import { VueRenderer } from "@tiptap/vue-3";
import tippy from "tippy.js";

import MentionList from "./MentionList.vue";

export default {
    char: "{",
    items: ({ query }: { query: string }) => {
        // Define all available merge tags
        const mergeTags = [
            "FIRST_NAME",
            "LAST_NAME",
            "EMAIL",
            "PHONE",
            "DATE",
            "TIMEZONE",
            "LOCATION_LABEL",
            "LOCATION_VALUE",
            "EVENT_NAME",
            "DURATION",
            "CANCEL_LINK",
            "VOCATIVE_FIRST_NAME",
        ];

        // Filter tags based on query
        const filteredMergeTags = mergeTags
            .filter((item) => item.toLowerCase().includes(query.toLowerCase()))
            .slice(0, 10);

        return filteredMergeTags;
    },

    render: () => {
        let component: any;
        let popup: any;

        return {
            onStart: (props: any) => {
                component = new VueRenderer(MentionList, {
                    // using vue 3:
                    props,
                    editor: props.editor,
                });

                if (!props.clientRect) {
                    return;
                }

                popup = tippy("body", {
                    getReferenceClientRect: props.clientRect,
                    appendTo: () => document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: "manual",
                    placement: "bottom-start",
                    theme: "light",
                    maxWidth: "none",
                });
            },

            onUpdate(props: any) {
                component.updateProps(props);

                if (!props.clientRect) {
                    return;
                }

                popup[0].setProps({
                    getReferenceClientRect: props.clientRect,
                });
            },

            onKeyDown(props: any) {
                if (props.event.key === "Escape") {
                    popup[0].hide();
                    return true;
                }

                return component.ref?.onKeyDown(props);
            },

            onExit() {
                if (popup && popup[0]) {
                    popup[0].destroy();
                }
                if (component) {
                    component.destroy();
                }
            },
        };
    },
};
